import { render, staticRenderFns } from "./taskQueue.vue?vue&type=template&id=0d7027a8&"
import script from "./taskQueue.vue?vue&type=script&lang=js&"
export * from "./taskQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports